import React from 'react'

type SkeletonElementProps ={
  type: any;
}
const SkeletonElement: React.FC<SkeletonElementProps> = ({ type }) => {
  const classes = `skeleton ${type}`
  return (
    <div className={classes}></div>
  )
}

export default SkeletonElement;